import { all, call, takeLatest } from 'redux-saga/effects';

import { SETTINGS } from './constants';

function* updateSettings({ settings }) {
  yield call(
    () =>
      new Promise((resolve) => {
        localStorage.setItem('settings', JSON.stringify(settings));
        resolve(true);
      })
  );
}

export const handleUpdateSettings = (settings) => ({
  type: SETTINGS.update,
  settings,
});

export const handleUpdateResponsive = (responsive = false) => ({
  type: SETTINGS.responsive,
  responsive,
});

export default function* saga() {
  yield all([yield takeLatest(SETTINGS.update, updateSettings)]);
}
